import { render, staticRenderFns } from "./email_dialog.vue?vue&type=template&id=ba9a1bd4&scoped=true"
import script from "./email_dialog.vue?vue&type=script&lang=js"
export * from "./email_dialog.vue?vue&type=script&lang=js"
import style0 from "./email_dialog.vue?vue&type=style&index=0&id=ba9a1bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9a1bd4",
  null
  
)

export default component.exports